import React from "react";
import { useDispatch } from "react-redux";

import {
	Modal,
	Button,
	Icon
} from "rhombus-react";

import { closeModal } from "reducers/Modal";

import "./ErrorImportSocialCreativesModal.css";

const PLATFORM_IMAGES = {
	Google: "/images/GoogleDiscovery.png",
};

export default function ErrorImportSocialCreativesModal({ filename, errorObj = {} }){
	const dispatch = useDispatch()
		, title = `Error Importing Social Creatives ${filename}`
		;

	function onClose(){
		dispatch(closeModal());
	}

	 function RenderRows(errors){
		if(!errors || !Object.values(errors).length){return null;}

		return Object.values(errors).map((val)=>{
			let { sheet, line, message, key } = val
				, [platform] = sheet.split(" ")
				, iconName = `${platform.toLowerCase()}image`;

			const iconSrc = PLATFORM_IMAGES[platform];
			const icon = iconSrc ? (<img src={iconSrc} aria-hidden className="social-error" />) : (<Icon className={`${sheet} social-error`} name={iconName} />);

			return(
				<tr key={key}>
					<td className="text-center sheet-cell">
						{icon}
					</td>
					<td className="text-center">
						{line}
					</td>
					<td>
						<span>{message}</span>
					</td>
				</tr>
			);
		});
	}

	function renderContent(){
		const columnHeadings = [
				{ heading:"Sheet", classAlign:"text-center" },
				{ heading:"Row", classAlign:"text-center" },
				{ heading:"Error Message", classAlign:"" }
			]
			, $headingRow = columnHeadings.map((ea)=>{
				return(<th className={`error-col ${ea.classAlign}`} scope="col" key={ea.heading}>{ea.heading}</th>);
			});

		return(
			<div className="bulk-error container">
				<div className="info">The following errors were encountered during import, no changes were made. Please adjust your spreadsheet accordingly and try again.</div>
				<table className="bulk-import-error basic-table">
					<thead className="header">
						<tr className="headrow">
							{$headingRow}
						</tr>
					</thead>
					<tbody>
						{Object.keys(errorObj).map((v) => {
							return <RenderRows key={v} {...errorObj[v]}  />;
						})}
					</tbody>
				</table>
			</div>
		);
	}

	function renderFooter(){
		return (
			<Button theme = "default" onClick = {onClose} >
				Close
			</Button>
		);
	}

	let bladeProps = {
			verticallyCenter: true,
		}
		, headerProps = {
			icon: "clearCircle",
			className: "bulk-import-error",
		};

	const errorImportModalProps = {
		title,
		type:						"modal",
		className:			"error-import-social-creatives-modal",
		xClose:					true,
		allowFullScreen:false,
		bladeProps,
		headerProps,
		renderContent,
		renderFooter,
		onClose,
	};

	return <Modal {...errorImportModalProps} />;
}

ErrorImportSocialCreativesModal.displayName = "ErrorImportSocialCreativesModal";
